







































































































































































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import ModalBatalSoap from "@/components/modal/ModalBatalSoap.vue";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import { storePasien } from "@/store/modules/pasien";
import Adime from "@/services/Adime";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { AdimeDetail, AdimeKategori } from "@/types/cppt";
import { STATUS_GIZI_ANAK, STATUS_GIZI_DEWASA } from "@/constants/gizi";

const USIA_DEWASA = 18;

function defaultDetail(): AdimeDetail {
  return {
    kategori: null,
    umur_tahun: null,
    bb: null,
    tb: null,
    imt: null,
    bb_u: null,
    tb_u: null,
    bb_tb: null,
    status_gizi: null,
    biokimia: null,
    suhu: null,
    tekanan_darah: null,
    rr: null,
    nadi: null,
    kebiasaan_makan: null,
    recall_asupan: null,
    alergi_makanan: null,
    pantangan_makanan: null,
    catatan_assessment: null,
    diet: null,
    bentuk_makanan: null,
    frekuensi_pemberian: null,
    rute: null,
    ekstra: null,
    energi: null,
    protein: null,
    catatan_intervensi: null
  };
}

function klasifikasiImt(imt: number | null): string | null {
  if (imt === null) return null;
  if (imt < 17) return STATUS_GIZI_DEWASA[0];
  if (imt < 18.5) return STATUS_GIZI_DEWASA[1];
  if (imt <= 25) return STATUS_GIZI_DEWASA[2];
  if (imt <= 27) return STATUS_GIZI_DEWASA[3];
  return STATUS_GIZI_DEWASA[4];
}

@Component({
  components: {
    ModalBatalSoap,
    VCDateTimePicker
  }
})
export default class AdimeInput extends Vue {
  @Ref() readonly sub;
  @Prop({ type: Boolean, default: false }) readonly readonly?: boolean;
  @Prop() value: {
    id: number;
    register_id: number;
    pasien_cm: string;
    unit_id: string;
    assessment: string;
    diagnosis: string;
    intervention: string;
    monitoring: string;
    evaluation: string;
    detail?: AdimeDetail | null;
    examined_at: string;
    verified_at: string;
  };
  @Prop({ type: Boolean, default: false }) isActive?: boolean;

  isFormValid = true;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  id = null;
  detail: AdimeDetail = defaultDetail();
  diagnosis: string = null;
  monitoring: string = null;
  evaluation: string = null;
  examinedAt: Date = null;
  verifiedAt: string | Date = null;

  kategoriTersimpan: AdimeKategori = null;
  kategoriManual: AdimeKategori = null;
  statusGiziSaran: string = null;

  removing = false;
  saving = false;

  showBatal = false;

  @Watch("value", {
    deep: true
  })
  changedValue(newVal, oldVal) {
    if (!newVal) {
      this.clearInput();
    } else if (newVal != oldVal) {
      // mode edit
      this.id = newVal.id;
      const tersimpan = newVal.detail || null;
      const detail = { ...defaultDetail(), ...(tersimpan || {}) };
      if (!tersimpan) {
        detail.catatan_assessment = newVal.assessment || null;
        detail.catatan_intervensi = newVal.intervention || null;
      }
      this.kategoriTersimpan = tersimpan ? tersimpan.kategori : null;
      this.statusGiziSaran = klasifikasiImt(this.hitungImt(detail.bb, detail.tb));
      this.detail = detail;
      this.diagnosis = newVal.diagnosis;
      this.monitoring = newVal.monitoring;
      this.evaluation = newVal.evaluation;
      this.examinedAt = newVal.examined_at;
      this.verifiedAt = newVal.verified_at;
    }
  }

  @Watch("imtOtomatis")
  onImtChanged(imt: number | null) {
    if (this.kategoriAktif !== "dewasa" || this.readonly) return;
    const saran = klasifikasiImt(imt);
    if (!this.detail.status_gizi || this.detail.status_gizi === this.statusGiziSaran) {
      this.detail.status_gizi = saran;
    }
    this.statusGiziSaran = saran;
  }

  datetimeInput() {
    const dtime = new Date();
    if (this.examinedAt > dtime) {
      this.$nextTick(() => {
        this.examinedAt = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

  get tglLahir(): moment.Moment | null {
    const raw = storePasien.identitasPasien?.tgl_lahir;
    if (!raw) return null;
    const m = moment(raw, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
    return m.isValid() ? m : null;
  }

  get umurTahun(): number | null {
    if (!this.tglLahir) return null;
    const acuan = this.examinedAt ? moment(this.examinedAt) : moment();
    const umur = acuan.diff(this.tglLahir, "years");
    return umur >= 0 ? umur : null;
  }

  get umurTampil(): number | null {
    if (this.kategoriTersimpan && this.id) {
      return this.detail.umur_tahun ?? null;
    }
    return this.umurTahun;
  }

  get kategoriOtomatis(): AdimeKategori {
    if (this.umurTahun === null) return null;
    return this.umurTahun < USIA_DEWASA ? "anak" : "dewasa";
  }

  get kategoriAktif(): AdimeKategori {
    if (this.id && this.kategoriTersimpan) return this.kategoriTersimpan;
    return this.kategoriOtomatis || this.kategoriManual;
  }

  get perluPilihKategori(): boolean {
    return !(this.id && this.kategoriTersimpan) && !this.kategoriOtomatis;
  }

  get rulesAntropometri() {
    const bebas = !!this.detail.catatan_assessment;
    return [v => bebas || (v !== null && v !== "") || "*Kolom ini harus diisi"];
  }

  get rulesDiet() {
    const bebas = !!this.detail.catatan_intervensi;
    return [v => bebas || !!v || "*Kolom ini harus diisi"];
  }

  get opsiStatusGizi(): string[] {
    return this.kategoriAktif === "anak" ? STATUS_GIZI_ANAK : STATUS_GIZI_DEWASA;
  }

  get imtOtomatis(): number | null {
    return this.hitungImt(this.detail.bb, this.detail.tb);
  }

  hitungImt(bb, tb): number | null {
    const b = parseFloat(bb);
    const t = parseFloat(tb);
    if (!b || !t || b <= 0 || t <= 0) return null;
    return Math.round((b / Math.pow(t / 100, 2)) * 10) / 10;
  }

  get canEdit() {
    return this.isNakes && this.id;
  }

  get canMakeSoap() {
    return this.isNakes;
  }

  get isNakes() {
    return this.activeUser.is_nakes;
  }

  get registerId(): number {
    return Number.parseInt(this.$route.params.register);
  }

  get pasienRm(): string {
    return this.$route.params.rm;
  }

  get activeUser() {
    return userModule.user;
  }

  get formatedExaminedAt() {
    if (!this.examinedAt) return null;
    return this.examinedAt instanceof Date
      ? moment(this.examinedAt.setSeconds(new Date().getSeconds())).format(
          "YYYY-MM-DD HH:mm:ss"
        )
      : moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss");
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get detailPayload(): AdimeDetail {
    const anak = this.kategoriAktif === "anak";
    const kosong = v => (v === "" || v === undefined ? null : v);
    const d: AdimeDetail = { ...defaultDetail() };
    Object.keys(d).forEach(k => {
      d[k] = kosong(this.detail[k]);
    });
    d.kategori = this.kategoriAktif;
    d.umur_tahun = this.umurTampil;
    d.imt = anak ? null : this.imtOtomatis;
    if (!anak) {
      d.bb_u = null;
      d.tb_u = null;
      d.bb_tb = null;
    }
    return d;
  }

  get input() {
    return {
      register_id: this.registerId,
      pasien_rm: this.pasienRm,
      unit_id: this.id ? this.value.unit_id : this.activeUser.unit_id,
      detail: this.detailPayload,
      diagnosis: this.diagnosis,
      monitoring: this.monitoring,
      evaluation: this.evaluation,
      examined_at: this.formatedExaminedAt
    };
  }

  get isVerified() {
    return this.verifiedAt ? true : false;
  }

  async mounted() {
    this.clearInput();
    this.$nextTick(() => {
      this.sub?.focus();
    });
  }

  async save() {
    if (this.saving || this.readonly || !this.kategoriAktif) return;

    const form = this.$refs.form as Vue & { validate: () => boolean };
    if (form && !form.validate()) {
      appModule.sendErrorAlert("Lengkapi kolom ADIME yang wajib diisi");
      return;
    }

    this.saving = true;

    try {
      const isEdit = !!this.id;
      const resp = this.id
        ? await Adime.update(this.id, this.input)
        : await Adime.create(this.input);

      if (!this.id) {
        this.id = resp["id"];
      }

      this.clearInput();
      appModule.sendSuccessNotice(
        isEdit ? "ADIME berhasil diubah" : "ADIME berhasil disimpan"
      );

      this.getByRegister();
    } finally {
      this.saving = false;
    }
  }

  get isDisabledInput() {
    return false;
  }

  get disabledInputMsg() {
    return null;
  }

  async remove(alasan = null) {
    if (!this.removing) {
      this.removing = true;

      try {
        await Adime.destroy(this.id, alasan?.alasan);

        await this.getByRegister();

        this.clearInput();
      } finally {
        this.removing = false;
      }
    }
  }

  async getByRegister() {
    await CpptRanapStore.getAdimeByRegister(this.registerId);
  }

  removeHandler() {
    const q = confirm("Menghapus Catatan ADIME ini?");

    if (q) {
      this.remove();
    }
  }

  clearInput() {
    this.id = null;
    this.detail = defaultDetail();
    this.diagnosis = null;
    this.monitoring = null;
    this.evaluation = null;
    this.examinedAt = null;
    this.verifiedAt = null;
    this.kategoriTersimpan = null;
    this.statusGiziSaran = null;
    (this.$refs.form as Vue & { resetValidation?: () => void })?.resetValidation?.();

    this.$emit("input", null);
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }
}
